import React from 'react';
import { PlugIcon, TargetIcon, BoxIcon } from 'lucide-react';
export const HowItWorksSection = () => {
  const steps = [{
    id: 1,
    title: 'Connect',
    description: 'Authorize Contextuality to analyze your digital communication channels in two clicks; set-up takes minutes.',
    icon: PlugIcon
  }, {
    id: 2,
    title: 'See the Pulse in Real Time',
    description: 'Validated psycholinguistic models translate daily dialogue into live signals—stress, burnout risk, social connection, and more.',
    icon: BoxIcon
  }, {
    id: 3,
    title: 'Act & Improve',
    description: 'Targeted, research-backed guidance arrives in your DMs, showing leaders what to adjust and how to elevate team health.',
    icon: TargetIcon
  }];
  return <section id="how-it-works" className="py-20 bg-gray-50" data-id="element-108">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-109">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-110">
          How It Works
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-111">
          {steps.map(step => <div key={step.id} className="bg-white rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-112">
              <div className="flex justify-center mb-6" data-id="element-113">
                <div className="bg-[#F5F8FF] p-4 rounded-full" data-id="element-114">
                  <step.icon size={28} className="text-[#8679DF]" data-id="element-115" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-center mb-3" data-id="element-116">
                {step.title}
              </h3>
              <p className="text-gray-700 text-center" data-id="element-117">{step.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};